module.exports = __webpack_public_path__ + "res/dummy_survey.0eed902037169f59bae97861b6d7b6a8.png";